/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Back',
    SCAN_QR_CODE: 'Scan the QR code'
  },
  ERRORS: {
    GET_DOCUMENT: 'Unable to get the document.',
    INVALID_CODE: 'Invalid code.',
    VALIDATING_CODE: 'Unable to validate the code.'
  },
  LABELS: {
    DELIVERY_ORDER: 'Delivery order',
    ERROR: 'Error',
    OR: 'Or',
    PACKAGE: 'Package',
    TRACKING_OR_CODE: 'Tracking number or package code'
  }
};
